import { defineMessage } from 'services/localization';

export const messages = {
    everyMonth: defineMessage('every_month'),
    everyMonthsStartingIn: defineMessage('b_n_b_months_starting_in_b_month_b'),
    specificMonth: defineMessage('specific_month_choose_one_or_many'),
    everyMonthBetween: defineMessage('b_month_b_and_b_month_b'),
    every: defineMessage('every'),
    startingMonth: defineMessage('months_starting_in'),
    selectMonths: defineMessage('select_months'),
    monthBetween: defineMessage('every_month_between'),
    and: defineMessage('and'),
    monthScheduler: defineMessage('month_scheduler'),
};
